import clearForm from 'root/src/client/logic/form/actions/clearForm'
import anchors from 'root/src/shared/constants/anchors'

export default (_, { moduleKey, moduleId }) => (dispatch) => {
	dispatch(clearForm({ moduleId, moduleKey, clear: true }))
	window.scrollTo(anchors.TOP, anchors.TOP)
}
